import Splide from "@splidejs/splide";
import { generalStore } from "./GeneralStore.js";

export class Sliders2 {
  timelineSliderInit() {
    if (document.querySelector(".splide__timeline")) {
      let timelineSplide = new Splide(".splide__timeline", {
        type: "loop",
        pagination: false,
        arrows: false,
        padding: { left: 0, right: "400px" },
        perPage: 1,
        autoplay: true,
        breakpoints: {
          1024: {
            padding: { left: 0, right: "100px" },
          },
        },
      });

      timelineSplide.mount();
    }
  }

  teamSliderInit() {
    if (document.querySelector(".splide__team")) {
      let teamSplide = new Splide(".splide__team", {
        type: "loop",
        arrows: false,
        pagination: false,
        perPage: 4,
        perMove: 1,
        breakpoints: {
          1601: {
            perPage: 3,
          },
          769: {
            padding: { left: "25%", right: "25%" },
            perPage: 1,
            autoWidth: false,
          },
          601: {
            padding: { left: "15%", right: "15%" },
            perPage: 1,
            autoWidth: false,
          },
          463: {
            padding: { left: "10%", right: "10%" },
            perPage: 1,
            autoWidth: false,
          },
        },
      });

      teamSplide.mount();

      document.getElementById("team-prev")?.addEventListener("click", () => {
        teamSplide.go("<");
      });

      document.getElementById("team-next")?.addEventListener("click", () => {
        teamSplide.go(">");
      });
    }
  }

  reviewsSliderInit() {
    if (document.querySelector(".splide__reviews")) {
      let reviewsSplide = new Splide(".splide__reviews", {
        type: "loop",
        perMove: 1,
        padding: { left: 0, right: 0 },
        arrows: false,
        autoWidth: true,
        pagination: false,
        breakpoints: {
          1025: {
            padding: { left: "100px", right: "100px" },
            autoWidth: false,
          },
          840: {
            padding: { left: "50px", right: "50px" },
            autoWidth: false,
          },
          465: {
            padding: { left: "40px", right: "25px" },
            autoWidth: false,
          },
        },
      });

      reviewsSplide.mount();

      // Refresh slider on window resize to recalculate widths/padding
      let resizeTimeout;
      window.addEventListener("resize", () => {
        clearTimeout(resizeTimeout);
        resizeTimeout = setTimeout(() => {
          reviewsSplide.refresh();
        }, 150);
      });

      Array.from(document.getElementsByClassName("review-prev")).forEach(
        (item) => {
          item.addEventListener("click", () => {
            reviewsSplide?.go("<");
          });
        }
      );

      Array.from(document.getElementsByClassName("review-next")).forEach(
        (item) => {
          item.addEventListener("click", () => {
            reviewsSplide?.go(">");
          });
        }
      );
    }
  }

  referencesSliderInit() {
    if (
      !document.querySelector(".splide__references") ||
      !document.querySelector(".splide__references-heading")
    )
      return;

    const mainSlider = new Splide(".splide__references", {
      type: "loop",
      perPage: 1,
      perMove: 1,
      arrows: false,
      pagination: false,
    });

    const headingSlider = new Splide(".splide__references-heading", {
      type: "loop",
      perPage: 1,
      perMove: 1,
      arrows: false,
      pagination: false,
    });

    mainSlider.sync(headingSlider);

    headingSlider.mount();
    mainSlider.mount();

    mainSlider.on("moved", (newIndex) => {
      generalStore.setState({ currentReferencesSlide: newIndex });
    });

    document
      .querySelector(".btn-prev")
      ?.addEventListener("click", () => mainSlider.go("<"));
    document
      .querySelector(".btn-next")
      ?.addEventListener("click", () => mainSlider.go(">"));
  }
}
